import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import globalProgramStore from '../../../../stores/program-store';
import { getProgramExternalExamDetailsOperation } from './operations/get-program-external-exam-details-operation';
import { StudentGradesByProgramType } from '../../../../api/types/programs/external-exams/program-external-exam';
import { AbstractExternalExamStudentGrades } from '../../../../api/types/programs/external-exams/program-external-exam';

export const ProgramPageExternalExamsTab = observer(() => {
  const [data, setData] = useState<StudentGradesByProgramType | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const currentProgramId = globalProgramStore.getCurrentId();
      if (!currentProgramId) return;

      const program = globalProgramStore.programs.get(currentProgramId);
      if (!program) return;

      const branchId = program.metadata.branchId;
      if (!branchId) return;

      await getProgramExternalExamDetailsOperation(
        branchId,
        currentProgramId,
        setData,
        setLoading,
      );
    };

    fetchData();
  }, []);

  const getStudentExamGrade = (
    studentExams: Record<string, AbstractExternalExamStudentGrades[]>,
    examId: number,
  ): string => {
    const examRegistrations = studentExams[examId.toString()];
    if (!examRegistrations || examRegistrations.length === 0) {
      return 'לא קיים ציון';
    }

    // Check if any registration has a finalGrade
    const hasFinalGrade = examRegistrations.some(
      (reg) => reg.finalGrade !== null && reg.finalGrade !== undefined,
    );

    if (hasFinalGrade) {
      // If student has final grade, display the max value of externalGrade
      const externalGrades = examRegistrations
        .map((reg) => reg.externalGrade)
        .filter(
          (grade): grade is number => grade !== null && grade !== undefined,
        );
      if (externalGrades.length > 0) {
        return Math.max(...externalGrades).toString();
      }
    }

    // If no final grade exists, display "לא קיים ציון"
    return 'לא קיים ציון';
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'right', padding: '20px' }}>טוען נתונים...</div>
    );
  }

  if (!data || !data.students || data.students.length === 0) {
    return (
      <div style={{ textAlign: 'right', padding: '20px' }}>
        לא נמצאו סטודנטים או מבחנים חיצוניים
      </div>
    );
  }

  return (
    <div style={{ marginTop: '16px' }}>
      <DataTable
        value={data.students}
        emptyMessage={
          <div style={{ textAlign: 'right' }}>לא נמצאו סטודנטים</div>
        }
        dataKey="studentId"
        loading={loading}
        tableStyle={{
          direction: 'rtl',
        }}
      >
        <Column
          style={{ textAlign: 'right' }}
          header="שם משתמש"
          body={(rowData) => (
            <div>
              {rowData.firstName} {rowData.lastName}
            </div>
          )}
        />
        {data.exams.map((exam) => (
          <Column
            key={exam.id}
            style={{ textAlign: 'right' }}
            header={exam.examName}
            body={(rowData) => (
              <div>{getStudentExamGrade(rowData.exams, exam.id)}</div>
            )}
          />
        ))}
      </DataTable>
    </div>
  );
});
